export default __webpack_public_path__ + "fonts/Titillium_Web-300-latin2.woff2";